const PWA_INSTALL_EVIDENCE_KEY = "pwa-install-evidence";

const readEvidence = (storage) => {
  try {
    const raw = storage?.getItem(PWA_INSTALL_EVIDENCE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (_error) {
    return null;
  }
};

const writeEvidence = (storage, evidence) => {
  try {
    storage?.setItem(PWA_INSTALL_EVIDENCE_KEY, JSON.stringify(evidence));
  } catch (_error) {
    // Ignore storage failures to avoid breaking startup.
  }
};

export const markPwaStandaloneLaunch = ({
  storage = window.localStorage,
  version = null,
  now = new Date().toISOString(),
} = {}) => {
  const previous = readEvidence(storage) || {};

  writeEvidence(storage, {
    ...previous,
    hasStandaloneLaunch: true,
    lastStandaloneAt: now,
    lastStandaloneVersion: version,
    lastSuspectedUninstallVersion: null,
    lastSuspectedUninstallAt: null,
  });
};

export const getPwaInstallEvidence = ({
  storage = window.localStorage,
} = {}) => {
  return readEvidence(storage);
};

export const detectSuspectedPwaUninstall = ({
  storage = window.localStorage,
  version = null,
  isStandalone = false,
  isInstallable = false,
  isWebview = false,
  platform = "unknown",
  detectionMode = "installable_after_standalone",
  now = new Date().toISOString(),
} = {}) => {
  if (isStandalone) {
    markPwaStandaloneLaunch({ storage, version, now });
    return null;
  }

  if (isWebview || !isInstallable) {
    return null;
  }

  const evidence = readEvidence(storage);

  if (!evidence?.hasStandaloneLaunch) {
    return null;
  }

  if (evidence.lastSuspectedUninstallVersion === version) {
    return null;
  }

  const nextEvidence = {
    ...evidence,
    lastSuspectedUninstallVersion: version,
    lastSuspectedUninstallAt: now,
  };

  writeEvidence(storage, nextEvidence);

  return {
    message:
      "Подозрение на удаление установленного PWA-приложения после предыдущего standalone-запуска",
    severity: "warn",
    context: {
      eventType: "suspected_pwa_uninstall",
      detectionMode,
      platform,
      currentVersion: version,
      previousStandaloneAt: evidence.lastStandaloneAt || null,
      previousStandaloneVersion: evidence.lastStandaloneVersion || null,
      detectedAt: now,
      isStandalone,
      isInstallable,
      isWebview,
    },
  };
};
